module.exports = __webpack_public_path__ + "img/env.c8b0689.png";